export function getEnumKeyByValue(enumType: any, enumValue: string): string {
  const valueIndex = Object.keys(enumType).indexOf(enumValue);
  const keys = Object.keys(enumType);
  return valueIndex > -1 ? keys[valueIndex] : undefined;
}
